import React from 'react';
import connect from "react-redux/es/connect/connect";
import {injectIntl} from "react-intl";
import Api from "../../../services/Api";
import {saveAs} from "file-saver";

class Document extends React.Component {

  downloadFile = (document)=>{
    Api.get(`/file?key=${document.key}`).then(response=>{
        saveAs(response, document.name);
      }
    ).catch(error=>console.log(error));
  }

  render() {
    const {document, canWrite} = this.props;

    return (
      <div className="document-item">
        <a onClick={()=>this.downloadFile(document)} className="document-item__link">
          <svg className="document-item__icon">
            <use xlinkHref="#icon-file-pdf"/>
          </svg>
          {document.name}
        </a>



        {canWrite &&
        <button className="document-item__delete" onClick={() => this.props.onDelete(document)}>
          <svg className="document-item__delete-icon">
            <use xlinkHref="#icon-cross-circle"/>
          </svg>
        </button>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Document))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/attachments/Document.js